import { Box } from "@mui/material";
import React, { useState } from "react";
import Header from "components/Header";
import AddEnquiry from "./AddEnquiry";
import EnquiryTable from "./EnquiryTable";
import Cards from "./Cards";
import EnquiryAnalytics from "./Analytics/EnquiryAnalytics";

const Enquiries = () => {
  const [filters, setFilters] = useState({});

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title={"Enquiries"}
        subtitle="Contains data related to enquiries"
        button={<AddEnquiry />}
      />

      <EnquiryAnalytics />
      <Cards setFilters={setFilters} />
      <EnquiryTable filters={filters} setFilters={setFilters} />  
      
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginTop={2}
      ></Box>
    </Box>
  );
};

export default Enquiries;
